import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import _ from 'underscore';
import type { CSSProperties, SFC } from 'react';

import type { LicenseSummary } from '../../../shared/types/licenses';
import type { License } from '../../types';

import LicenseTermPill from './LicenseTermPill';

const detailWrapperStyles: CSSProperties = {
  marginBottom: '16px',
};

const LicenseDetail: SFC<{
  license: License & {
    Summary?: LicenseSummary;
  };
}> = ({ license }) => (
  <div style={detailWrapperStyles}>
    <h5>
      {license.name}
    </h5>
    <p>{license.Summary ? license.Summary.summary : license.licenseComments}</p>
    {license.Summary && (
      <div>
        {_.chain(license.Summary.Terms || [])
          .filter(term => term.role === 'MUST')
          .map(term => (
            <OverlayTrigger
              key={term.termId}
              placement="top"
              overlay={
                <Tooltip>
                  {term.custom_description || term.termId}
                </Tooltip>
            }
          >
              <span style={{ cursor: 'help' }}>
                <LicenseTermPill term={term} />
              </span>
            </OverlayTrigger>
          ))
          .value()}
      </div>
    )}
  </div>
);

export default LicenseDetail;
